import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

interface SyncOrderRequest {
  OrderId: number;
}

interface SyncOrderState {
  isLoading: boolean;
  data: any;
  error: string | null;
}

const initialState: SyncOrderState = {
  isLoading: false,
  data: null,
  error: null,
};

export const syncOrder = createAsyncThunk<any, SyncOrderRequest>(
  "SyncOrderSlice/syncOrder",
  async (requestDetails, thunkApi) => {
    try {
      const response = await httpClient.post("/order", {
        Action: "syncToCRM",
        OrderId: Number(requestDetails.OrderId),
      });

      if (response.status !== 200 || response.data.Status !== "success") {
        if (response.data.Status === "error") {
          return thunkApi.rejectWithValue({
            message: response.data.Message,
          });
        }
        return thunkApi.rejectWithValue({
          message: "Failed to sync order.",
        });
      }

      return response.data;
    } catch (error: any) {
      console.log("🚀 ~ error:", error);
      return thunkApi.rejectWithValue({
        message: "Failed to sync order.",
      });
    }
  },
);

const SyncOrderSlice = createSlice({
  name: "SyncOrderSlice",
  initialState,
  reducers: {
    resetSyncOrderState: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(syncOrder.pending, (state) => {
        state.isLoading = true;
        state.data = null;
        state.error = null;
      })
      .addCase(syncOrder.fulfilled, (state, action: PayloadAction<any>) => {
        if (action.payload.Status === "success") {
          state.isLoading = false;
          state.data = action.payload.Data ?? action.payload;
          state.error = null;
        } else {
          state.isLoading = false;
          state.data = null;
          state.error = action.payload.message;
        }
      })
      .addCase(syncOrder.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.data = null;
        state.error = action?.payload?.message || "Failed to sync order.";
      });
  },
});

export const { resetSyncOrderState } = SyncOrderSlice.actions;

export default SyncOrderSlice.reducer;
